import { render, staticRenderFns } from "./IconSvgFolder.vue?vue&type=template&id=e45a37ba&scoped=true&"
import script from "./IconSvgFolder.vue?vue&type=script&lang=js&"
export * from "./IconSvgFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45a37ba",
  null
  
)

export default component.exports